/*!
 * Job Search Board - Version: 1.1.12
 * Indeed - Copyright (c) 2025
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */

let jobBoardLastWhatVal = "";
let jobBoardLastWhereVal = "";
let jobBoardLastCursor = null;
const ALLOWED_LABELS = new Set(allowedJobAttributeLabels);
const MAXIMUM_ALLOWED_LABELS = 3; 
const FETCH_MORE_JOBS_TIMEOUT_MS = 15000;
function timeout(ms) {
    return new Promise((_, reject) => {
        setTimeout(() => {
            reject(new Error(`Timeout after ${ms} milliseconds`));
        }, ms);
    });
}
let abortController = null;
async function fetchAndDisplayJobs(requestedCursor) {
    if (!jobClickOGAK) {
        console.error("Missing required key.");
        return;
    }
    const isIndeedQa = window.location.hostname.endsWith('indeed.net');

    const whatVal = document.getElementById("prompt_what").value;
    const whereVal = document.getElementById("prompt_where").value;
    const cursor = (whatVal === jobBoardLastWhatVal && whereVal === jobBoardLastWhereVal) ? requestedCursor : null;
    jobBoardLastWhatVal = whatVal;
    jobBoardLastWhereVal = whereVal;
    const cookieName = 'CTK';
    const ctk = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)')?.pop() || '';
    const apiKey = isIndeedQa ? jobClickOGAKQ : jobClickOGAK;

    const headers = new Headers();
    headers.append(
        'Indeed-API-Key',
        apiKey
    );
    headers.append('Content-Type', 'application/json');
    const graphql = JSON.stringify({
        query: `query Query(
            $what: String!
            $where: String!
            $jobClickTrackingFrom: String!
            $cursor: String
            $limit: Int!
            $jobBoardClientName: JobBoardClientName!
            $indeedCtk: String!
            $indeedCo: CountryCode!
            $languageCode: LanguageCode!
        ) {
  curatedCampaignJobSearch(input: {
        what: $what,
        where: $where,
        jobClickTrackingFrom: $jobClickTrackingFrom,
        cursor: $cursor,
        limit: $limit,
        jobBoardClientName: $jobBoardClientName,
        indeedCtk: $indeedCtk,
        indeedCo: $indeedCo,
        languageCode: $languageCode
  }) {
    results {
      job {
        employer {
          name
          ugcStats {
            ratings {
              overallRating {
                value
              }
            }
          }
        }
        location {
          formatted {
            long
          }
          neighborhood
        }
        dateLastAnnotated
        title
        tracking {
          jobClick {
            url
          }
        }
        indeedApply {
            pingbackUrl
        }
        attributes {
            label
        }
        compensation {
          formattedText
        }
        hiringDemand {
          isUrgentHire
          isHighVolumeHiring
        }
      }
      snippet {
        text
      }
      auction
    }
    pageInfo {
      nextCursor
    }
    estimatedTotalResultsCount
  }
}`,
        variables: {
            "what": whatVal,
            "where": whereVal,
            "jobClickTrackingFrom": jobClickTrackingFrom,
            "cursor": cursor,
            "limit": 15,
            "jobBoardClientName": jobClickOGCE.trim(), 
            "indeedCtk": ctk,
            "indeedCo": getLocale().co,
            "languageCode": getLocale().hl
        }
    });
    if (abortController) {
        abortController.abort();
    }
    abortController = new AbortController();
    const abortSignal = abortController.signal;
    const requestOptions = {
        method: 'POST',
        headers: headers,
        body: graphql,
        redirect: 'follow',
        signal: abortSignal
    };
    const apiUrl = isIndeedQa ? 'https://apis.qa.indeed.net/graphql' : 'https://apis.indeed.com/graphql';

    const response = await fetch(apiUrl, requestOptions);
    const ccJobSearchResult = await response.json();
    return ccJobSearchResult;
}

async function fetchNewJobs() {
    window.scrollTo(0, 0);
    document.querySelector(".job-board-loading").style.display = 'flex';
    document.getElementById("job-results-request-more").style.display = 'none';
    document.querySelector(".job-board-no-results").innerHTML = '';
    let ccJobSearchResult;
    try {
        ccJobSearchResult = await fetchAndDisplayJobs(null);
    } catch(error) {
        console.error(error);
        return;
    }
    document.querySelector(".job-board-loading").style.display = 'none';
    if(ccJobSearchResult.data?.curatedCampaignJobSearch?.results?.length > 0) {
        document.querySelector(".job-board-no-results").style.display = 'none';
        document.querySelector(".job-board-no-results").innerHTML = '';
    } else {
        document.querySelector(".job-board-no-results").style.display = 'block';
        const userQuery = `<strong>${escapeHtml(document.getElementById("prompt_what").value)} ${escapeHtml(document.getElementById("prompt_where").value)}</strong>`;
        const noResultsMessageStr =  (noResultsMessage && noResultsMessage.includes('%s'))
            ? noResultsMessage.replace('%s', userQuery)
            : `The search ${userQuery} did not match any jobs. Please try a new search.`;
        document.querySelector(".job-board-no-results").innerHTML = noResultsMessageStr;
    }
    displayJobList(ccJobSearchResult, false);
}
async function trackSearchBtnClick() {
    if (window.commonMetricsLibrary) {
        window.commonMetricsLibrary.report({
            "data-tn-element": "job-search-button",
            "data-tn-action": "click",
        });
    }
}

async function fetchMoreJobs() {
    document.getElementById("more-jobs-btn-label").style.display = 'none';
    document.getElementById("more-jobs-btn-icon").style.display = 'none';
    document.getElementById("more-jobs-btn-loading-icon").style.display = 'block';
    const cardCount = document.querySelectorAll(".job-results-card a").length;
    const lastCard = document.querySelectorAll(".job-results-card a").item(cardCount - 1);
    if (lastCard) {
        lastCard.focus();
        lastCard.blur();
    }
    document.getElementById("more-jobs-btn").disabled = true;
    try {
        const jobSearchResult = await Promise.race([fetchAndDisplayJobs(jobBoardLastCursor), timeout(FETCH_MORE_JOBS_TIMEOUT_MS)]);
        displayJobList(jobSearchResult, true);
    }
    catch(e) {console.error(e);}
    finally {
        document.getElementById("more-jobs-btn-loading-icon").style.display = 'none';
        document.getElementById("more-jobs-btn-label").style.display = 'block';
        document.getElementById("more-jobs-btn-icon").style.display = 'block';
        document.getElementById("more-jobs-btn").disabled = false;
    }
}
async function trackMoreJobsBtnClick() {
    if (window.commonMetricsLibrary) {
        window.commonMetricsLibrary.report({
            "data-tn-element": "more-jobs-button",
            "data-tn-action": "click",
        });
    }
}

document.getElementById("job_search_btn").addEventListener("click", setQueryParamsFromSearchInput);
document.getElementById("job_search_btn").addEventListener("click", fetchNewJobs);
document.getElementById("job_search_btn").addEventListener("click", trackSearchBtnClick);

document.getElementById("more-jobs-btn").addEventListener("click", fetchMoreJobs);
document.getElementById("more-jobs-btn").addEventListener("click", trackMoreJobsBtnClick);
async function trackJobResultsCardClickBackup() {
    if (window.commonMetricsLibrary) {
        window.commonMetricsLibrary.report({
            "data-tn-element": "job-results-card-backup",
            "data-tn-action": "click-backup",
        });
    }
}

function displayJobList(ccJobSearchResult, append) {
    const cardList = document.getElementById("job-results-list");
    if (!append) {
        cardList.replaceChildren();
    }
    let counter = cardList.childElementCount;

    if (ccJobSearchResult?.data?.curatedCampaignJobSearch?.results) {
        jobBoardLastCursor = ccJobSearchResult?.data?.curatedCampaignJobSearch?.pageInfo?.nextCursor;
        const moreJobsDiv = document.getElementById("job-results-request-more");
        if (jobBoardLastCursor) {
            moreJobsDiv.style.display = "block";
            moreJobsDiv.style.visibility = "visible";
        } else {
            moreJobsDiv.style.visibility = "hidden";
        }
        for (const result of ccJobSearchResult?.data?.curatedCampaignJobSearch?.results) {
            if (!result?.job) {
                continue;
            }
            counter+=1;
            const job = result.job;
            const title = job.title;
            const descriptionSnippet = result.snippet?.text || ''; 
            const companyName = job.employer?.name || '';
            const companyRating = job.employer?.ugcStats?.ratings?.overallRating?.value || '';
            const canEasyApply = !!job.indeedApply?.pingbackUrl;
            const isUrgentHire = job.hiringDemand?.isUrgentHire || false;
            const isHighVolumeHiring = job.hiringDemand?.isHighVolumeHiring || false;
            const jobAttributes = job.attributes || [];
            const jobLocation = job.location?.formatted?.long || '';
            const jobCompensation = job.compensation?.formattedText || '';
            const jobNeighborHood = job.location?.neighborhood ? ` <span class="job-card-neighborhood">(${job.location?.neighborhood})</span>` : '';
            const jobRecencyMs = job.dateLastAnnotated ? Date.now() - job.dateLastAnnotated : 0;
            const jobRecencyDays = Math.trunc(jobRecencyMs / (1000 * 60 * 60 * 24));
            const jobRecencyDaysStr = jobRecencyDays >= 30
                ? '30+'
                : `${jobRecencyDays}`;
            const activeDaysAgoStr = (jobPostingRecencyLabel && jobPostingRecencyLabel.includes('%s'))
                ? jobPostingRecencyLabel.replace('%s', jobRecencyDaysStr)
                : `Active ${jobRecencyDaysStr} days ago`; 
            const jobRecencyStr = jobRecencyDays > 1.0
                ? activeDaysAgoStr
                : postedJustNowLabel;
            const url = job.tracking?.jobClick?.url || '';
            const generateCompanyNameHTML = (companyName, companyRating) => {
                let html = '';
                if (companyName) {
                    html += `<p>${companyName}</p>`;
                    if (companyRating) {
                        html += `<p>${companyRating} &#9733</p>`;
                    }
                }
                return html;
            };
            const generateJobMetadataHTML = (jobCompensation, jobAttributes) => {
                let html = '';
                if (jobCompensation) {
                    html += `<div class='job-card-job-metadata'>${jobCompensation}</div>`;
                }

                let labelCount = 0;
                for (const attribute of jobAttributes) {
                    if (ALLOWED_LABELS.has(attribute.label)) {
                        html += `<div class='job-card-job-metadata'>${attribute.label}</div>`;
                        labelCount += 1;
                        if (labelCount === MAXIMUM_ALLOWED_LABELS) {
                            break;
                        }
                    }
                }
                if (html.length > 0) {
                    return `<div class="job-card-job-metadata-group"> ${html} </div>`;
                } else {
                    return '';
                }
            };
            const generateHiringMetadataHTML = (canEasyApply, isUrgentHire, isHighVolumeHiring) => {
                let html = '';
                if (canEasyApply) {
                    html += `<div class="job-card-hiring-metadata"><div class="easy-apply-icon"></div><div>${easilyApplyLabel}</div></div>`;
                }
                if (isUrgentHire) {
                    html += `<div class="job-card-hiring-metadata"><div class="urgent-hiring-icon"></div><div>${urgentlyHiringLabel}</div></div>`;
                }
                if (isHighVolumeHiring) {
                    html += `<div class="job-card-hiring-metadata"><div class="high-volume-hiring-icon"></div><div>${hiringMultipleCandidatesLabel}</div></div>`;
                }
                if (html.length > 0) {
                    return `<div class="job-card-hiring-metadata-group"> ${html} </div>`;
                } else {
                    return '';
                }
            };
            const maybeSponsoredJobLabel = shouldDisplayAdvertisementLabel(getLocale().co) && result.auction
                ? `
                    <span class="job-card-sponsored-job-label">${sponsoredJobLabel}</span>
                    <span class="job-card-footer-separator">&#183;</span>
                `
                : '';
            const cardHtmlStr = `
            <div id="job-results-card-${counter}" class="job-results-card">
                <a href="${url}" target="_blank" data-tn-element="job-results-card">
                    <div class="job-results-card-internal">
                        <div class="job-card-job-title">
                            <h2>${title}</h2>
                            <div class="right-arrow-icon"></div>
                        </div>
                        <div class="job-card-company-name">
                            ${generateCompanyNameHTML(companyName, companyRating)}
                        </div>
                        <div class="job-card-job-location">
                            <p>${jobLocation}${jobNeighborHood}</p>
                        </div>
                        ${generateJobMetadataHTML(jobCompensation, jobAttributes)}
                        ${generateHiringMetadataHTML(canEasyApply, isUrgentHire, isHighVolumeHiring)}
                        <div class="job-card-snippet">
                            <p>${descriptionSnippet}</p>
                        </div>
                        <div class="job-card-footer">
                            ${maybeSponsoredJobLabel}
                            <span class="job-card-recency-string">${jobRecencyStr}</span>
                        </div>
                    </div>
                </a>
            </div>
            `;
            cardList.insertAdjacentHTML('beforeend', cardHtmlStr);
        }
    }
    const jobResultsCards = document.querySelectorAll(`[data-tn-element="job-results-card"]`);
    jobResultsCards.forEach(jobResultsCard =>
        jobResultsCard.addEventListener("click", trackJobResultsCardClickBackup, { once: true }));
}
function getGnavConfig() {
    const gnavConfigElement = document.getElementById("_indeed_gnav_config");

    if (gnavConfigElement !== null) {
        const gnavConfig = JSON.parse(gnavConfigElement.textContent);
        return gnavConfig;
    }

    return null;
}
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
function getLocale() {
    const locale = {
        hl:'en',
        co:'US'
    };
    const gnavConfig = getGnavConfig();
    if (gnavConfig) {
        locale.hl = gnavConfig.language || locale.hl;
        locale.co = gnavConfig.country || locale.country;
    } else {
        const hn = window.location.hostname;
        if (hn.endsWith('.wpengine.com') || hn.endsWith('.wpengine.test')) {
            if (hn[2] === "-" && hn[5] === ".") {
                locale.hl = hn.substring(0, 2).toLowerCase();
                locale.co = hn.substring(3, 5).toUpperCase();
            }
        }
    }
    return locale;
}
function getAutocompleteApiEndpoint() {
    let isPreproduction = true;
    const gnavConfig = getGnavConfig();
    if (gnavConfig) {
        isPreproduction = getGnavConfig().isPreproduction;
    }
    if (isPreproduction) {
        return 'https://autocomplete.sandbox.qa.indeed.net/api/v0';
    } else {
        return 'https://autocomplete.indeed.com/api/v0';
    }
}

window.addEventListener('AutocompleteLoaded', function() {
    if (!window.autocomplete) {
        console.error('autocomplete library not properly loaded');
        return;
    }
    const whatInput = document.getElementById('prompt_what');
    const whatContainer = document.getElementById('what_container');
    const whereInput = document.getElementById('prompt_where');
    const whereContainer = document.getElementById('where_container');
    const pageId = 'job-search-board';
    const baseAutoCompleteConfig = {
        page: pageId,
        country: getLocale().co,
        language: getLocale().hl,
        count: 8,
        endpoint: getAutocompleteApiEndpoint(),
        userIdentifiers: { ctk: getCookie('CTK') },
        debounce: true,
        debounceTimeoutInMs: 200
    };
    const whatConfig = Object.assign({type: 'what'}, baseAutoCompleteConfig);
    const whereConfig = Object.assign({type: 'location'}, baseAutoCompleteConfig);
    window.autocomplete.create(whatConfig, whatInput, whatContainer);
    window.autocomplete.create(whereConfig, whereInput, whereContainer);
});
document.querySelector('#prompt_what_icon').addEventListener('click', function(event) {
    const whatInput =  document.querySelector('#prompt_what');
    whatInput.value="";
    whatInput.blur();

});
document.querySelector('#prompt_where_icon').addEventListener('click', function(event) {
    const whereInput =  document.querySelector('#prompt_where');
    whereInput.value="";
    whereInput.blur();
});

document.querySelector('#prompt_what').addEventListener('keydown', (event) => {
    if (event.key === 'Enter') { 
        const whatInput =  document.querySelector('#prompt_what');
        const searchButton = document.querySelector('#job_search_btn');
        if (whatInput === document.activeElement && whatInput.value && whatInput.value.trim().length>0) {
            searchButton.click();
            whatInput.blur();
        }
    }
});
document.querySelector('#prompt_where').addEventListener('keydown', (event) => {
    if (event.key === 'Enter') { 
        const whereInput =  document.querySelector('#prompt_where');
        const searchButton = document.querySelector('#job_search_btn');
        if (whereInput === document.activeElement && whereInput.value && whereInput.value.trim().length>0) {
            searchButton.click();
            whereInput.blur();
        }
    }
});
function setQueryParamsFromSearchInput() {
    const origin = window.location.origin;
    const path = window.location.pathname;
    const query = new URL(location).searchParams;
    const whatInputValue = document.getElementById("prompt_what").value;
    const whereInputValue = document.getElementById("prompt_where").value;
    const whatQueryParamValue = decodeURIComponent(query.get('what') || '');
    const whereQueryParamValue = decodeURIComponent(query.get('where') || '');
    if (whatInputValue === whatQueryParamValue && whereInputValue === whereQueryParamValue) {
        return;
    }
    const url = new URL(origin + path);
    if (whatInputValue) {
        url.searchParams.append('what', encodeURIComponent(whatInputValue));
    }
    if (whereInputValue) {
        url.searchParams.append('where', encodeURIComponent(whereInputValue));
    }
    window.history.pushState(
        null,
        '',
        url
    );
}
function setSearchInputFromUrlParam() {
    const query = new URL(location).searchParams;
    const whatQueryParamValue = decodeURIComponent(query.get('what') || '');
    const whereQueryParamValue = decodeURIComponent(query.get('where') || '');
    const whatInput = document.getElementById("prompt_what");
    const whereInput = document.getElementById("prompt_where");
    whatInput.value = whatQueryParamValue;
    whereInput.value = whereQueryParamValue;
}
function escapeHtml(unsafeHTML)
{
    return unsafeHTML.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
}

const EU_EEA_EFTA_COUNTRIES = new Set([
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'CH',
    'IS',
    'LI',
    'NO',
]);
function shouldDisplayAdvertisementLabel(country) {
    return EU_EEA_EFTA_COUNTRIES.has(country.toUpperCase());
}

window.addEventListener('popstate', function () {
    setSearchInputFromUrlParam();
    fetchNewJobs();
});
window.addEventListener("load", (event) => {
    setSearchInputFromUrlParam();
    fetchNewJobs();
});
window.onbeforeunload = function () {
    window.scrollTo(0, 0);
};
